import styled from "styled-components";

export const LoginWrapper = styled.div`
    height: calc(100vh - 271px);
    form{
        width: 600px;
    }
    .btn-login{
        height: 40px;
    }
    .checkbox{
        height: 20px;
        width: 20px;
    }
`